import './site-picker-button.scss'
import '@/common/components/dateShowtimePicker/subcomponents/modalSitePickerWrapper/modal-site-picker.scss'
import type {
    ModalSitePickerProps,
    SiteModalHandles,
} from '@omnia/ui/src/lib/cms/components/modalSitePicker/ModalSitePicker'
import { ModalSitePicker } from '@omnia/ui/src/lib/cms/components/modalSitePicker/ModalSitePicker'
import { ModalSitePickerDisplayTextPropsApi } from '@omnia/ui/src/lib/cms/components/modalSitePicker/models'
import { getSelectedSites } from '@vista-digital/occ-domain'
import { Icon } from '@vista-digital/occ-ui'
import { observer } from 'mobx-react'
import { useRef } from 'react'
import { tooltipStore } from '@/common/components/tooltip/tooltip.store'
import { useInitialData } from '@/common/hooks/useInitialData'
import { cx } from '@/common/utils/className'

export const SitePickerButton = observer(() => {
    const { isTooltipVisible } = tooltipStore
    const displayText = useInitialData().header.modalSitePickerDisplayText

    const selectedSites = getSelectedSites().length
    const btnClassNames = cx('action-buttons__site-picker bg-off-white', { highlighted: isTooltipVisible })
    const sitePickerModalRef = useRef<SiteModalHandles>()
    const openSiteModalPicker = () => sitePickerModalRef.current?.showModal()
    const defaultDisplayText = new ModalSitePickerDisplayTextPropsApi()
    const modalSitePickerProps: ModalSitePickerProps = {
        ...defaultDisplayText,
        ...displayText,
        searchFormPosition: 'in-body',
        ctaClasses: {
            ctaClass: 'v-button v-button--color-primary',
        },
    }

    return (
        <>
            <button className={btnClassNames} onClick={openSiteModalPicker}>
                <Icon name="location-pin" />
                {selectedSites > 0 && <span className="counter-badge">{selectedSites}</span>}
            </button>
            <div className="modal-site-picker">
                <ModalSitePicker {...modalSitePickerProps} ref={sitePickerModalRef} />
            </div>
        </>
    )
})
